import { Truncation } from '@myn/mui';

type Props = {
  text: string;
};

const RegularTextCell = ({ text }: Props) => (
  <Truncation
    tooltipTitle={text}
    maxWidth={250}
    aria-label="permissions user text cell"
  >
    {text}
  </Truncation>
);

export default RegularTextCell;
